import { useTranslation } from 'react-i18next';
import SearchableSelect from '../searchableSelect/searchableSelect';
import { useWorkTimeActivitySelect } from './useWorkTimeActivitySelect';

interface WorkTimeActivitySelectProps {
  onOpenPicker: () => void;
  onClear: () => void;
}

/**
 * Its own component so the activity list is only fetched where the field is rendered. It renders the
 * trigger button directly, which lookup siblings like `LookupClearButton` rely on.
 */
const WorkTimeActivitySelect = ({
  onOpenPicker,
  onClear,
}: Readonly<WorkTimeActivitySelectProps>) => {
  const { t } = useTranslation();
  const select = useWorkTimeActivitySelect();

  return (
    <SearchableSelect
      {...select}
      ariaLabel={t('worktime:activity')}
      placeholder={t('worktime:selectActivity')}
      searchPlaceholder={t('task:search')}
      onSearchIconClick={onOpenPicker}
      onClear={onClear}
      data-field="activity"
      data-testid="worktime-activity-select-button"
    />
  );
};

export default WorkTimeActivitySelect;
